// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  direction: rtl;
  margin-right: 15px;
  margin-top: 15px;
}

.accept {
  width: 70px;
  background-color: green;
  color: white;
  margin-left: 10px;
}

.reject {
  width: 70px;
  background-color: red;
  color: white;
}

mat-dialog-content {
  width: 20rem !important;
  height: 7rem !important;
}

mat-dialog-actions {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modal/modal.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/shared/components/modal/modal.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;;ADCA;EACI,WAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;ACEJ;;ADCA;EACI,WAAA;EACA,qBAAA;EACA,YAAA;ACEJ;;ADAA;EACI,uBAAA;EACA,uBAAA;ACGJ;;ADDA;EACI,iBAAA;ACIJ","sourcesContent":["p {\r\n    direction: rtl;\r\n    margin-right: 15px;\r\n    margin-top: 15px;\r\n}\r\n.accept{\r\n    width: 70px;\r\n    background-color: green;\r\n    color: white;\r\n    margin-left: 10px;\r\n}\r\n\r\n.reject{\r\n    width: 70px;\r\n    background-color: red;\r\n    color: white;\r\n}\r\nmat-dialog-content{\r\n    width: 20rem !important;\r\n    height: 7rem !important;\r\n}\r\nmat-dialog-actions {\r\n    margin-left: 10px;\r\n}","p {\n  direction: rtl;\n  margin-right: 15px;\n  margin-top: 15px;\n}\n\n.accept {\n  width: 70px;\n  background-color: green;\n  color: white;\n  margin-left: 10px;\n}\n\n.reject {\n  width: 70px;\n  background-color: red;\n  color: white;\n}\n\nmat-dialog-content {\n  width: 20rem !important;\n  height: 7rem !important;\n}\n\nmat-dialog-actions {\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
